import axios from 'axios'
import { ProductTypes, ActionTypes, OptionTypes } from '../constants'
import { devLog } from '../functions'
import { catchError, calcPrice } from './'
import { checkAreaNum } from './areas'

//初期値取得
export const getInitialOptions = () => async dispatch => {
    let options
    //PHP initalaze
    if( 'initialOptions' in window ){
        devLog('getInitialOptions:window.initialOptions')
        options = window.initialOptions
        devLog('options',options)
    }
    else{
        let productTypeId = ProductTypes.PostingFlyer
        if( 'productTypeId' in window ){
            productTypeId = window.productTypeId
        }
        devLog('getInitialOptions:get_initial_options')
        let errFlg = false
        const response = await axios({
            method: 'POST',
            withCredentials: true,
            url: process.env.REACT_APP_API_URL + "",
            data: {
                mode:'get_initial_options',
                product_type_id: productTypeId,
            },
        }).catch( (e)=>{ errFlg = catchError(e) } );
        if (errFlg) return;
        options = response.data
        devLog('options',options)
    }

    dispatch({ type: ActionTypes.GET_INITIAL_OPTIONS, options: options });
    return;
}

export const selectOptions = (selected) => (dispatch, getState) => {
    if( 'houseTypeId' in selected ){
        const {areas} = getState();
        const new_list = areas.list.map((area)=>{
            let maxNum
            switch( selected.houseTypeId ){
                case OptionTypes.HOUSE_SINGLE:
                    maxNum= area.single
                    break;
                case OptionTypes.HOUSE_COMPLEX:
                    maxNum= area.complex
                    break;
                case OptionTypes.HOUSE_NONE:
                default:
                    maxNum= area.sum
                    break;
            }
            const {num,error} = checkAreaNum( area.num, maxNum )

            return {...area, num:num, maxNum:maxNum, error:error }
        })
        dispatch({
            type: ActionTypes.CHANGE_AREAS_HOUSE_TYPE,
            houseTypeId: selected.houseTypeId,
            list:new_list
        })
    }
    dispatch({ type: ActionTypes.SELECT_OPTIONS, selected: selected })
    dispatch(calcPrice())
}

export const selectOptionsUpdate = (select) => async (dispatch, getState) => {
    devLog('selectOptionsUpdate:select_options')
    const {options,areas} = getState();
    let errFlg = false
    const response = await axios({
        method: 'POST',
        withCredentials: true,
        url: process.env.REACT_APP_API_URL + "",
        data: {
            mode:'select_options',
            select: select,
            selected: options.selected,
            postNum: areas.sumNum,
        },
    }).catch( (e)=>{ errFlg = catchError(e) } );
    if (errFlg) return;
    const new_options = response.data
    devLog('new_options',new_options)
    dispatch({ type: ActionTypes.UPDATE_OPTIONS, options: new_options });
    dispatch(calcPrice())
}



// WEBPACK FOOTER //
// ./src/actions/options.js